import React, { useContext } from 'react';
import { Button, Card, Link, LocaleContext } from 'shared';
import { getEnvironmentVar } from 'utils';

import { HowToTestProps } from './HowToTest.types';

export const HowToTest = ({ apis }: HowToTestProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Card className="application-card how-to-test">
      <Card.Header className="how-to-test__header">
        <Card.Title className="how-to-test__title">
          {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.TITLE' })}
        </Card.Title>
      </Card.Header>
      <Card.Body className="how-to-test__body">
        <Card.Item className="how-to-test__name">
          <Card.ItemKey className="how-to-test__key">
            {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.ALLOWED-URLS.TITLE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="how-to-test__value how-to-test__name">
            {apis && apis.map((u, index) => <div key={index}>{u}</div>)}
          </Card.ItemValue>
        </Card.Item>
        <Card.Item className="how-to-test__name">
          <Card.ItemKey className="how-to-test__key">
            {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.INSTRUCTIONS.TITLE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="how-to-test__value how-to-test__name">
            {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.INSTRUCTIONS.DESCRIPTION' })}
          </Card.ItemValue>
        </Card.Item>
        <Card.Item className="how-to-test__name">
          <Card.ItemKey className="how-to-test__key">
            {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.LEARN-MORE.TITLE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="how-to-test__value how-to-test__name">
            <Link
              url={`${getEnvironmentVar('REACT_APP_SPA_URL')}documentation/sandbox`}
              external={true}
              target="_blank"
            >
              <Button type="portal-blue" className="how-to-test__button">
                {localeContext.formatMessage({ id: 'APPLICATION-HOW-TO-TEST.LEARN-MORE.VISIT-DOCUMENTATION' })}
              </Button>
            </Link>
          </Card.ItemValue>
        </Card.Item>
      </Card.Body>
    </Card>
  );
};
